import { Tabs, TabsList } from "@appretio/ui-kit";
import { useFetchForecastMetaData } from "../../hooks/useFetchForecastMetaData";
import { ForecastTableControlsBaseProps } from "./ForecastTableControls";
import { applyCalendarViewChange } from "./forecastTableControlUtils";
import type { ForecastTableControlValues } from "./forecastTableControlValues";

export function CalendarViewControls({
  options,
  setOptions,
  values,
  setValues
}: ForecastTableControlsBaseProps) {
  const { data: metaData } = useFetchForecastMetaData();

  function onValueChange(
    calendarType: ForecastTableControlValues["calendarView"]
  ) {
    const next = applyCalendarViewChange(
      calendarType,
      values,
      options,
      metaData
    );
    setOptions(next.options);
    setValues(next.values);
  }

  return (
    <Tabs
      value={values.calendarView}
      onValueChange={(v) =>
        onValueChange(v as ForecastTableControlValues["calendarView"])
      }
    >
      <TabsList triggers={options.calendarView} />
    </Tabs>
  );
}
